"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _cta = _interopRequireDefault(require("../../components/cta"));

var _utils = require("../../utils");

var _showMore = _interopRequireDefault(require("./show-more"));

var _results = _interopRequireDefault(require("./results"));

var _panelTitle = _interopRequireDefault(require("./panel-title"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /** Default handler for detail page onClick */
  detailPageAction: _propTypes.func,

  /** Default handler for download item onClick */
  downloadAction: _propTypes.func,

  /** Determines whether we show minimal UI */
  isRestricted: _propTypes.bool,

  /** Number of maximum items to show */
  maxItemsToShow: _propTypes.number.isRequired,

  /** Handler to be called when the show more button is clicked */
  moreButtonOnClick: _propTypes.func,

  /** Object with pane properties */
  pane: (0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    parentId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),

  /** Optional object to handle authorized resources */
  paneLink: (0, _propTypes.shape)({
    onClick: _propTypes.func.isRequired,
    text: _propTypes.string.isRequired
  }),

  /** Title of pane */
  paneTitle: _propTypes.string.isRequired,

  /** Array of results to display */
  resultItems: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** resultItem title text */
    title: _propTypes.string.isRequired,

    /** resultItem title onClick handler */
    titleHandler: _propTypes.func
  })).isRequired
};
var defaultProps = {
  paneLink: {
    onClick: (0, _ramda.always)(null),
    text: ""
  }
};

var ResultsPane = function ResultsPane(_ref) {
  var detailPageAction = _ref.detailPageAction,
      downloadAction = _ref.downloadAction,
      isRestricted = _ref.isRestricted,
      maxItemsToShow = _ref.maxItemsToShow,
      moreButtonOnClick = _ref.moreButtonOnClick,
      pane = _ref.pane,
      _ref$paneLink = _ref.paneLink,
      paneLinkText = _ref$paneLink.text,
      onClickPaneLink = _ref$paneLink.onClick,
      paneTitle = _ref.paneTitle,
      resultItems = _ref.resultItems;

  var _useToggle = (0, _utils.useToggle)(false),
      showAllResults = _useToggle[0],
      showMoreOnClick = _useToggle[1];

  var showMoreHandler = (0, _react.useCallback)(function (event) {
    if ((0, _ramda.is)(Function, moreButtonOnClick)) {
      moreButtonOnClick(Object.assign({
        event: event
      }, pane));
    } else {
      showMoreOnClick();
    }
  }, [moreButtonOnClick, pane, showMoreOnClick]);
  var showMoreButton = (0, _ramda.length)(resultItems) > maxItemsToShow;
  var visibleItems = showAllResults || !maxItemsToShow ? resultItems : (0, _ramda.take)(maxItemsToShow, resultItems);
  var extraItemsCount = showAllResults ? 0 : (0, _ramda.subtract)((0, _ramda.length)(resultItems), maxItemsToShow);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    as: "section",
    direction: "column",
    pb: [5],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexWrap: "wrap",
    justifyContent: "space-between",
    pb: [2],
    px: [3, 3, 2]
  }, /*#__PURE__*/_react["default"].createElement(_panelTitle["default"], {
    isRestricted: isRestricted,
    paneTitle: paneTitle
  }), isRestricted && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    pt: [1, 0],
    width: [1, "auto"]
  }, /*#__PURE__*/_react["default"].createElement(_cta["default"], {
    mb: 0,
    onClick: onClickPaneLink,
    version: "link"
  }, paneLinkText))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    width: 1
  }, (0, _ramda.length)(visibleItems) > 0 ? /*#__PURE__*/_react["default"].createElement(_results["default"], {
    detailPageAction: detailPageAction,
    downloadAction: downloadAction,
    isRestricted: isRestricted,
    visibleItems: visibleItems
  }) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    fontSize: 5,
    fontWeight: 2,
    my: 3,
    px: [3, 3, 2],
    tag: "p"
  }, "No ", paneTitle, " are currently available or match your search."), showMoreButton ? /*#__PURE__*/_react["default"].createElement(_showMore["default"], {
    delayIn: visibleItems.length * 0.04,
    extraItemsCount: extraItemsCount,
    isRestricted: isRestricted,
    showAllResults: showAllResults,
    showMoreOnClick: showMoreHandler
  }) : null));
};

ResultsPane.propTypes = propTypes;
ResultsPane.defaultProps = defaultProps;
ResultsPane.displayName = "Modules.ResultsPane";
var _default = ResultsPane;
exports["default"] = _default;